import React,{useEffect} from 'react';
import {connect} from 'react-redux';
import PreviewCollection from '../../components/preview-collection/preview-collection.component'
import {createStructuredSelector} from 'reselect'
import {selectCollectionsForPreview} from '../../redux/shop/shop.selectors'
import Banner from '../../components/banner'
import StyledHero from '../../components/StyledHero'
import './collections-overview.styles.scss'
import { useState } from 'react';
// import front from '../../assets/home.png'
import FormInput from '../form-input/form-input.component'
import Hero from '../../assets/shop.png'
// import Hero2 from '../../assets/300.png'
import {Helmet} from 'react-helmet'
const CollectionOverview = ({ collections }) => {
    const [search,setSearch] = useState({searchField:''})
    const{searchField} = search
    const handleChange = event => {
        const {value,name} = event.target;
        setSearch({...search,[name]: value})
    }
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
return(
    <>
    <Helmet> 
    <meta charset="utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1"/>
    <meta name="description" content="Looking for wireless gadgets?Here at Acceronix we provide you with wireless headphones,wireless gamepads and wireless speakers.Why wait?Shop wireless gadgets with us now."/>
    <title>Shop Wireless Gadgets in Pakistan | Acceronix</title>
    </Helmet>
    <StyledHero img={Hero} mob={Hero}>
        <Banner title="ORDER NOW"/>
    </StyledHero>
    <div style={{
        padding: '10px',
        margin: '10px'
    }} className='collection-overview'>
  
        {/* <FormInput
 
        id="shop"
        type="text" 
        name="searchField" 
        value={searchField} 
        required 
        handleChange={handleChange}
        label='Search'
        /> */}
         {
            collections.map(({id, ...otherCollectionProps}) =>(
               <PreviewCollection key={id} {...otherCollectionProps} search={searchField}/>
             ))
          }
    </div>
    </>
)
}
const mapStateToProps = createStructuredSelector({
    collections: selectCollectionsForPreview
})
export default connect(mapStateToProps)(CollectionOverview) 